import {Injectable} from '@angular/core';
import {Product, Brand} from '../../shared/models/models';
import {BrandDetails, ConfigApiControllerService} from "falcon-api";
import {map, tap} from 'rxjs/operators';
import {ProductService} from "./product.service";
import {NGXLogger} from "ngx-logger";
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  private brands: Array<Brand> = [];

  /**
   * Constructor
   * @param configApiService Config service instance.
   * @param productService Product service instance.
   * @param logger Logger instance.
   */
  constructor(private configApiService : ConfigApiControllerService,
              private productService : ProductService,
              private logger: NGXLogger,
              private toastr: ToastrService) {
  }

  /**
   * Get list of brands from service
   */
  async getBrands(): Promise<Array<Brand>> {
    return new Promise( (resolve, reject) => {
      let results = this.configApiService.getBrands1();
      results
        .pipe(
          map((items) => items
            .map(item => (new Brand(item.id as number, item.name as string,
        (item.products != undefined) ? item.products.map(
                product => (Product.mapFromDto(product))) : new Array<Product>())
            ))),
          tap(mappedItems => this.logger.debug(JSON.stringify(mappedItems)))
        )
        .subscribe((mappedItems) => {
          this.brands = mappedItems;
          resolve(this.brands);
        });
    });
  }

  /**
   * Add brand to service
   * @param brand Brand to add.
   */
  async addBrand(brand : Brand): Promise<Array<Brand>> {
    return new Promise( (resolve, reject) => {
      let brandDetails : BrandDetails = new BrandDetails();
      brandDetails.id = brand.id;
      brandDetails.name = brand.name;

      let results = this.configApiService.saveBrand(brandDetails);
      results.subscribe((next) => {
        resolve(this.getBrands());
      });
    });
  }

  /**
   * Delete brand from service
   * @param brand Brand to add
   */
  async deleteBrand(brand : Brand): Promise<Array<Brand>> {
    return new Promise( (resolve, reject) => {
      let results = this.configApiService.deleteBrand(brand.id);
      results.subscribe((next) => {
        resolve(this.getBrands());
      },
      (error) => {
        this.toastr.error('Something went wrong', 'Error');
      });
    });
  }

  /**
   * Update brand on service
   * @param brand Brand to update
   */
  async updateBrand(brand : Brand): Promise<Array<Brand>> {
    return new Promise( (resolve, reject) => {
      let brandDetails : BrandDetails = new BrandDetails();
      brandDetails.id = brand.id;
      brandDetails.name = brand.name;

      let results = this.configApiService.updateBrand(brandDetails);
      results.subscribe((next) => {
        resolve(this.getBrands());
      });
    });
  }

}
